<div class="wrapper">
  <div class="gradient-bar"></div>
  <mat-card>
    <img
      src="../../../assets/images/actabl-blue.png"
      alt="Actabl"
      class="actabl"
    />
    <mat-card-content>
      <h6>
        {{
          'pairing.' + (shouldCreateUser ? 'create' : 'connect') + '.title'
            | translate
              : { actablUnifiedAccount: 'actablUnifiedAccount' | translate }
        }}
      </h6>
      <p>
        <span>{{ (shouldCreateUser ? createText : connectText)[0] }}</span>
        <span
          class="underline"
          matTooltip="{{
            'pairing.actablHelper'
              | translate
                : {
                    actabl: 'Actabl',
                    actablUnifiedAccount: 'actablUnifiedAccount' | translate
                  }
          }}"
          >{{ 'actablUnifiedAccount' | translate }}</span
        >
        <span>{{ (shouldCreateUser ? createText : connectText)[1] }}</span>
      </p>

      <mat-divider></mat-divider>
      @if (shouldCreateUser) {
      <app-create-user-form></app-create-user-form>
      } @else {
      <app-pairing-form> </app-pairing-form>
      }

      <mat-divider></mat-divider>

      <mat-card-footer>
        <p>
          {{
            'pairing.' +
              (shouldCreateUser ? 'create' : 'connect') +
              '.createOrConnectQuestion'
              | translate
                : {
                    actablUnifiedAccount: 'actablUnifiedAccount' | translate
                  }
          }}
          <span class="toggle-form" (click)="toggleFormType()">{{
            'pairing.' +
              (shouldCreateUser ? 'create' : 'connect') +
              '.createOrConnectAction' | translate
          }}</span>
        </p>
      </mat-card-footer>
    </mat-card-content>
  </mat-card>
</div>
